import { render, staticRenderFns } from "./ArticlePopUp.vue?vue&type=template&id=43a9895e&scoped=true&"
import script from "./ArticlePopUp.vue?vue&type=script&lang=js&"
export * from "./ArticlePopUp.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePopUp.vue?vue&type=style&index=0&id=43a9895e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a9895e",
  null
  
)

export default component.exports